import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShipmentOrder } from 'slices/thunk';
import { RootState } from 'slices';

// SimpleBar
import SimpleBar from 'simplebar-react';

// Icons
import { MoreVertical, Calendar } from 'lucide-react';
import { Dropdown } from 'Common/Components/Dropdown';
import { Link } from 'react-router-dom';

const TodaysOrder = () => {
    const dispatch = useDispatch();
    const shipmentOrder = useSelector((state: RootState) => state.Ecommerce.shipmentOrder);

    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        console.log(shipmentOrder)
        dispatch(getShipmentOrder() as any);
    }, [dispatch]);

    useEffect(() => { 
        if (shipmentOrder && Array.isArray(shipmentOrder)) {
            const mapped = shipmentOrder. map((item: any, index: number) => ({
                shipperName: item.shipperName,
                receiverName: item.receiverName,
                delivery: new Date(item.delivery).toLocaleDateString(),
                status: item.status || "Delayed", // default status
            }));
            setData(mapped);
        }
    }, [shipmentOrder]);

    const Status = ({ item }: any) => {
        switch (item) {
            case "recieved":
                return (<span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-200 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20">{item}</span>);
            case "pending":
                return (<span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-yellow-200 border-yellow-200 text-yellow-500 dark:bg-yellow-500/20 dark:border-yellow-500/20">{item }</span>);
      
            default:
                return (<span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-white border-gray-400 text-gray-500">{item}</span>);
        }
    };

    return (
      <div className="col-span-3 card">
    <div className="!pb-0 card-body">
        <h6 className="mb-3 text-15">Today's Order</h6>
    </div>
    <div className=" overflow-hidden">
        <SimpleBar className="flex flex-col gap-4 px-5 h-[350px]  ">
            <div className="flex flex-col gap-3">
                {(data || []).map((item, key) => (
                    <div className="border rounded-md border-slate-200 dark:border-zink-500" key={key}>
                        <div className="flex flex-wrap items-center gap-3 p-2">
                            <div className="grow">
                                <h6 className="mb-1">
                                    <Link to="#!">{item.shipperName}</Link>
                                </h6>
                                <p className="text-slate-500">Manager: {item.receiverName}</p>
                            </div>
                            <Dropdown className="relative dropdown shrink-0">
                                <Dropdown.Trigger type="button" className="flex items-center justify-center size-[30px] p-0 bg-white text-slate-500 btn dark:bg-zink-500">
                                    <MoreVertical className="size-4" />
                                </Dropdown.Trigger>
                                <Dropdown.Content placement="right-end" className="absolute z-50 py-2 mt-1 list-none bg-white dark:bg-zink-500 rounded-md shadow-md dropdown-menu min-w-[10rem]">
                                    <li><Link className="block px-4 py-1.5 text-slate-600 dropdown-item dark:text-white" to="#!">Overview</Link></li>
                                    <li><Link className="block px-4 py-1.5 text-slate-600 dropdown-item dark:text-white" to="#!">Edit</Link></li>
                                    <li><Link className="block px-4 py-1.5 text-slate-600 dropdown-item dark:text-white" to="#!">Delete</Link></li>
                                </Dropdown.Content>
                            </Dropdown>
                        </div>
                        <div className="p-2 border-t border-slate-200 dark:border-zink-500">
                            <div className="flex flex-col gap-3 md:items-center md:flex-row justify-between">
                                <p className="text-slate-500 shrink-0">
                                    <Calendar className="inline-block size-4 mr-1" />
                                    {item.delivery}
                                </p>
                                <Status item={item.status} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </SimpleBar>
    </div>
</div>
    );
};

export default TodaysOrder;



